import React from 'react';
import {Field} from 'redux-form';
import PropTypes from 'prop-types';

import {withClientBookingsFilters} from '@modules/booking/HOC/withClientBookingsFilters';
import {BookingsFiltersFields} from '@modules/booking/components/BookingsFiltersFields';
import Form from '@appComponents/ReduxFormControls';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {DeviceCategoriesFilter} from '@utils/commonFilters/DeviceCategoriesFilter';
import {PackagesFilter} from '@utils/commonFilters/PackagesFilter';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {BookingTypesFilter} from '@utils/commonFilters/BookingTypesFilter';
import {CancellationStatusFilter} from '@utils/commonFilters/CancellationStatusFilter';
import {MatchEventTypesFilter} from '@utils/commonFilters/MatchEventTypesFilter';

const ClientEventBookingsFiltersComponent = (filtersProps) => {
    const {
        clientFilters,
        loading,
        restoreFilterValues,
        data: {
            products,
            eventContentTypes,
            matchEventTypes,
            deviceCategories,
            countries,
            clientPackages,
            bookingTypes,
        },
    } = filtersProps;

    return (
        <div className='filter__controls__container'>
            <BookingsFiltersFields {...filtersProps} />
            <ProductsFilter
                loading={loading}
                products={products}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <Field
                component={Form.ReduxSelect}
                disabled={loading}
                loading={loading}
                multiple
                name='eventContentTypes'
                placeholder='Event content type'
                options={eventContentTypes}
                search
                setValue={restoreFilterValues(clientFilters, 'eventContentTypes')}
            />
            <MatchEventTypesFilter
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
                options={matchEventTypes}
            />
            <DeviceCategoriesFilter
                deviceCategories={deviceCategories}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <PackagesFilter
                clientPackages={clientPackages}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <BookingTypesFilter
                bookingTypes={bookingTypes}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <CancellationStatusFilter
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

ClientEventBookingsFiltersComponent.propTypes = {
    filterProps: PropTypes.shape({
        clientFilters: PropTypes.object,
        data: PropTypes.objectOf(PropTypes.array),
        dataConfigProps: PropTypes.object,
        loading: PropTypes.bool,
        restoreFilterValues: PropTypes.func,
        restoreFilterDateValues: PropTypes.func,
    }),
};

export const ClientEventBookingsFilters = withClientBookingsFilters(ClientEventBookingsFiltersComponent, 'ClientEventBookings');

